import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const PetsRadar: Site = {
  id: 'petsradar',
  logo: 'svg/petsradar.svg',
  label: 'Pets Radar',
  analyticsName: 'petsradar',
  hostname: 'petsradar.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
